import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import OInput from '../../../UI/FormControls/OInput';
import DragAndDrop from '../../../UI/DragAndDrop';
import styles from './Inputs.module.css';
import CheckBox from '../../../UI/FormControls/CheckBox';
import noImage from '../Image/addImage.png';
import OAutocomplete from '../../../UI/MuiAutocomplete';
import useHttp from '../../../../hooks/use-http';
import Spinner from '../../../UI/Modal/Spinner';

const Inputs = ({
  formData,
  setFormData,
  b64Slika,
  setB64Slika,
  slika,
  setSlika,
  rabatnaGrupaData,
}) => {
  const dropzoneRef = useRef(null);
  const {
    sendRequest: vratiKlijente,
    data: klijentiData,
    isLoading,
  } = useHttp('');
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    console.log(name);
    console.log(event.target.checked);
    if (typeof formData[name] === 'boolean') {
      setFormData((curr) => {
        return { ...curr, [name]: event.target.checked };
      });
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  useEffect(() => {
    const config = {
      url: 'Kupci/vrati_podatke_partnera_CRM',
    };
    vratiKlijente(config);
  }, []);
  const handleFiles = (files) => {
    setFormData((curr) => {
      return { ...curr, files: files };
    });

    const base64Image = URL.createObjectURL(files[0]);
    setSlika(base64Image);
  };
  const handleDeleteFile = () => {
    setFormData((curr) => {
      return { ...curr, files: [] };
    });
    setB64Slika('');
  };
  const handleClickRabat = (item) => {
    setFormData((curr) => {
      return {
        ...curr,
        idRabatneGrupe: item.id,
        nazivRabatneGrupe: item.vrednost,
      };
    });
  };
  const handleClickKlijent = (item) => {
    setFormData((curr) => {
      return {
        ...curr,
        idKlijenta: null,
        nazivKlijenta: '',
        nazivFirme: '',
        adresa: '',
      };
    });
    setFormData((curr) => {
      return {
        ...curr,
        idKlijenta: item.id,
        nazivKlijenta: item.vrednost,
        nazivFirme: item.vrednost,
        adresa: item.adresa,
      };
    });
  };
  return (
    <div
      style={{
        display: 'flex',
        gap: '10px',
        marginBottom: '20px',
        flexWrap: 'wrap',
      }}
    >
      {isLoading && <Spinner />}{' '}
      <OAutocomplete
        data={klijentiData}
        value={formData.nazivKlijenta || ''}
        handleClick={handleClickKlijent}
        label="Klijent"
        style={{ width: '350px' }}
      />
      <OInput
        label="Naziv Firme"
        name="nazivFirme"
        value={formData.nazivFirme}
        handleChange={handleInputChange}
        style={{ width: '300px' }}
      />
      <OInput
        label="Adresa"
        name="adresa"
        value={formData.adresa}
        handleChange={handleInputChange}
        style={{ width: '300px' }}
      />
      <OInput
        label="Kontakt Telefon"
        name="kontaktTelefon"
        value={formData.kontaktTelefon}
        handleChange={handleInputChange}
        style={{ width: '250px' }}
      />
      <OInput
        label="Email"
        name="email"
        value={formData.email}
        handleChange={handleInputChange}
        style={{ width: '250px' }}
      />
      <OAutocomplete
        data={rabatnaGrupaData}
        value={formData.nazivRabatneGrupe || ''}
        handleClick={handleClickRabat}
        label="Rabatna grupa"
        style={{ width: '250px' }}
      />
      <CheckBox
        style={{ height: '70px' }}
        label="Ino"
        handleChange={handleInputChange}
        checked={formData.ino}
        name="ino"
      />
      <div className={styles.fileContainer}>
        {/* <img
          alt="noImage"
          src={b64Slika ? `data:image/png;base64,${b64Slika}` : noImage}
          style={{ height: '75px', width: '100px', objectFit: 'contain' }}
          onClick={() => {
            dropzoneRef.current.click();
          }}
        /> */}
        {b64Slika || slika ? (
          slika.startsWith('blob:') ? (
            <img
              style={{ height: '75px', width: '100px', objectFit: 'contain' }}
              alt="noImage"
              src={slika}
              onClick={() => {
                dropzoneRef.current.click();
              }}
            />
          ) : (
            <img
              style={{ height: '75px', width: '100px', objectFit: 'contain' }}
              alt="noImage"
              src={`data:image/jpeg;base64,${b64Slika}`}
              onClick={() => {
                dropzoneRef.current.click();
              }}
            />
          )
        ) : (
          <img
            style={{ height: '75px', width: '100px', objectFit: 'contain' }}
            alt="noImage"
            src={noImage}
            onClick={() => {
              dropzoneRef.current.click();
            }} // Zamenite sa stvarnom putanjom do zamenske slike
          />
        )}
        <div style={{ display: 'none' }}>
          <DragAndDrop
            ref={dropzoneRef}
            handleFiles={handleFiles}
            maxFiles={1}
            addedFiles={[]}
            handleRemoveFile={handleDeleteFile}
          />
        </div>
      </div>
    </div>
  );
};

Inputs.propTypes = {
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
};

export default Inputs;
